import { useQuery } from "@tanstack/react-query";
import { useAuthContext } from "BEDROCK/auth/auth-provider";

export interface DashboardData {
  users: {
    total: number;
    newInPeriod: number;
    activeInPeriod: number;
  };
  orders: {
    created: number;
    newInPeriod: number;
  };
  mobileSignups: {
    unconverted: number;
    converted: number;
  };
  stripe: {
    revenueInPeriod: number;
    transactionCount: number;
    averageOrderValue: number;
    currentBalance: number;
  };
  timeRange: number;
}

export const useDashboardData = (timeRange: number = 30) => {
  const { client, session } = useAuthContext();

  const fetchDashboardData = async (): Promise<DashboardData> => {
    if (!client) throw new Error("useDashboardData: Client not initialized");
    if (!session) throw new Error("useDashboardData: No active session");

    const { data, error } = await client.functions.invoke(
      "admin-dashboard-data",
      {
        headers: {
          Authorization: `Bearer ${session.access_token}`,
        },
        body: {
          timeRange,
        },
      }
    );

    if (error) throw error;
    return data as DashboardData;
  };

  return useQuery<DashboardData, Error>({
    queryKey: ["dashboardData", timeRange],
    queryFn: fetchDashboardData,
    enabled: !!session,
    staleTime: 60000, // 1 minute
    refetchInterval: 300000, // Auto-refresh every 5 minutes
  });
};
